import Vue from 'vue';

import AppInput from '@/components/Layout/Inputs/AppInput.vue';
import AppPageHeader from '@/components/Layout/AppPageHeader.vue';
import AppAutocomplete from '@/components/Layout/Inputs/AppAutocomplete.vue';
import AppFilePicker from '@/components/Layout/Inputs/AppFilePicker.vue';
import AppTermVerificationModal from '@/components/Modal/TermVerificationModal.vue';
import AppImageCropper from '@/components/ImageCropper/AppImageCropper.vue';

Vue.component('app-input', AppInput);
Vue.component('app-page-header', AppPageHeader);
Vue.component('app-autocomplete', AppAutocomplete);
Vue.component('app-file-picker', AppFilePicker);
Vue.component('app-term-verification-modal', AppTermVerificationModal);
Vue.component('app-image-cropper', AppImageCropper);
